import { render, staticRenderFns } from "./backgroundManage.vue?vue&type=template&id=48c674b0&scoped=true&"
import script from "./backgroundManage.vue?vue&type=script&lang=js&"
export * from "./backgroundManage.vue?vue&type=script&lang=js&"
import style0 from "./backgroundManage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./backgroundManage.vue?vue&type=style&index=1&id=48c674b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c674b0",
  null
  
)

export default component.exports